var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "master-card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9778 11.0417H7.02734V1.32285H12.9778V11.0417Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.63892 6.1814C7.63818 7.11724 7.85033 8.04099 8.25931 8.88274C8.66829 9.72449 9.26338 10.4622 9.99954 11.04C9.08776 11.7566 7.99278 12.2021 6.83974 12.3258C5.6867 12.4495 4.52212 12.2463 3.4791 11.7394C2.43608 11.2326 1.55671 10.4425 0.941483 9.45947C0.326257 8.47646 0 7.3402 0 6.18054C0 5.02088 0.326257 3.88462 0.941483 2.90162C1.55671 1.91861 2.43608 1.12852 3.4791 0.62165C4.52212 0.114778 5.6867 -0.0884275 6.83974 0.0352583C7.99278 0.158944 9.08776 0.604531 9.99954 1.32109C9.26315 1.89908 8.66792 2.63705 8.25893 3.47911C7.84995 4.32118 7.63792 5.24527 7.63892 6.1814Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.0005 6.18141C20.0004 5.02167 19.6741 3.88533 19.0588 2.90229C18.4434 1.91926 17.5639 1.12918 16.5208 0.62238C15.4776 0.115581 14.3129 -0.0874929 13.1598 0.0363703C12.0067 0.160234 10.9117 0.606038 10 1.32282C10.7359 1.90114 11.3308 2.63904 11.7399 3.48083C12.149 4.32263 12.3615 5.24634 12.3615 6.18227C12.3615 7.1182 12.149 8.04191 11.7399 8.88371C11.3308 9.7255 10.7359 10.4634 10 11.0417C10.9117 11.7585 12.0067 12.2043 13.1598 12.3282C14.3129 12.452 15.4776 12.249 16.5208 11.7422C17.5639 11.2354 18.4434 10.4453 19.0588 9.46225C19.6741 8.47921 20.0004 7.34287 20.0005 6.18313V6.18141Z",
    fill: "url(#paint0_linear_723_2242)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_2242",
    x1: 21.8025,
    y1: 12.2862,
    x2: 15.0002,
    y2: 0.00101511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.d5fb524012d3b722f81ca09fbc1546ae.svg";
export { ForwardRef as ReactComponent };